<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';

export default {
	extends: Base,
  	data(){
	    return {
			Name:"BoTrxDocument",
			DocAccessType:{},
			DocAccessTypePopup:{},
			DocDepartment:{},
			DocType:{},
			mrClient:{},
			ClientContact:{},
			ClientProject:{},
			ClientContactPopup:{},
			doc_department:{},
			detail:'',
			total_document:'',
			total_document_range:'',
			row2: {contact_person:[]},
			MrSalutation: {},
			DocProductType:{},
	    }
  	},
  	mounted(){
    	this.$set(this.$root, 'page', this)
		this.refreshData()
		$(document).on('hidden.bs.modal', '#addNewAccessType', ()=>{
		  	if(this.row.td_doc_access_type == '-1') this.$set(this.row, 'td_doc_access_type', '')
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewDocDepartment', ()=>{
		  	if(this.row.td_doc_department == '-1') this.$set(this.row, 'td_doc_department', '')
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewDocType', ()=>{
		  	if(this.row.td_doc_type == '-1') this.$set(this.row, 'td_doc_type', '')
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewClient', ()=>{
		  	if(this.row.td_client_id == '-1') this.$set(this.row, 'td_client_id', '')
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewCP', ()=>{
			if(this.row.td_cp == '-1') this.$set(this.row, 'td_cp', '')
		  	this.row2 = {contact_person:[]}
		});
		$(document).on('hidden.bs.modal', '#addNewProject', ()=>{
			if(this.row.td_project_id == '-1') this.$set(this.row, 'td_project_id', '')
		  	this.row2 = {contact_person:[]}
		});
	},
	methods:{
		openDetail: function(v){
			$("#detailDocument").modal();
			BOGen.apirest("/"+this.Name,{type:'detail', id:v.id},(e,resp)=>{
				if(e) return console.log(e);
				this.detail = resp;
			},'POST')
        },
        addNewAccessType: function(e){
            if(e.val == -1){
            	$("#addNewAccessType").modal();
            }
        },
        submitAccessType(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addAccessType'}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewAccessType").modal("hide");
		          	this.DocAccessType.push(resp.newAccessType)
		          	this.$set(this.row, 'td_doc_access_type', resp.lastAccessType)
		          })
		        }
			},'POST')
        },
        addNewDocDepartment: function(e){
            if(e.val == -1){
            	$("#addNewDocDepartment").modal();
            }
        },
        submitDocDepartment(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addDocDepartment'}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewDocDepartment").modal("hide");
		          	this.DocDepartment.push(resp.newDocDepartment)
		          	this.$set(this.row, 'td_doc_department', resp.lastDocDepartment)
		          })
		        }
			},'POST')
        },
        addNewDocType: function(e){
            if(e.val == -1){
            	$("#addNewDocType").modal();
            }
        },
        submitDocType(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addDocType', id:this.row.td_doc_access_type}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewDocType").modal("hide");
		          	this.DocType.push(resp.newDocType)
		          	this.$set(this.row, 'td_doc_type', resp.lastDocType)
		          })
		        }
			},'POST')
        },
        addNewClient: function(e){
            if(e.val == -1){
            	$("#addNewClient").modal();
            }
        },
        submitClient(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addClient'}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewClient").modal("hide");
		          	this.mrClient.push(resp.newClient)
		          	this.$set(this.row, 'td_client_id', resp.lastClient)
		          })
		        }
			},'POST')
        },
        addNewCP: function(e){
            if(e.val.indexOf('-1') > -1){
            	$("#addNewCP").modal();
            }
        },
        submitCP(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addCP', id:this.row.td_client_id}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewCP").modal("hide");
		          	this.ClientContact.push(resp.newCP)
		          	this.$set(this.row, 'td_cp', resp.lastCP)
		          })
		        }
			},'POST')
        },
        addNewProject: function(e){
            if(e.val.indexOf('-1') > -1){
            	$("#addNewProject").modal();
            }
        },
        submitProject(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addProject', id:this.row.td_client_id}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewProject").modal("hide");
		          	this.ClientProject.push(resp.newProject)
		          	this.$set(this.row, 'td_project_id', resp.lastProject)
		          })
		        }
			},'POST')
        },
	},
  	watch:{
	    '$route.query'(v){ this.refreshData() },
	    'filter.client'(v){ this.search() },
	    'filter.project'(v){ this.search() },
	    'filter.doc'(v){ this.search() },
	    'row.td_client_id':function(v){
	    	BOGen.apirest("/"+this.Name,Object.assign({type:'getCP', id:v}),(e,resp)=>{
				if(e) return console.log(v);
				this.ClientContact = resp;
				if(this.row.td_cp) this.$set(this.row, "td_cp", this.row.td_cp)
			},'POST')
	    	BOGen.apirest("/"+this.Name,Object.assign({type:'getProject', id:v}),(e,resp)=>{
				if(e) return console.log(v);
				this.ClientProject = resp;
				if(this.row.td_project_id) this.$set(this.row, "td_project_id", this.row.td_project_id)
			},'POST')
			BOGen.apirest("/"+this.Name,Object.assign({type:'getCPPopup', id:v}),(e,resp)=>{
				if(e) return console.log(v);
				this.ClientContactPopup = resp;
				if(this.row2.tp_cp_id) this.$set(this.row2, "tp_cp_id", this.row2.tp_cp_id)
			},'POST')
	    },
	    'row.td_doc_access_type':function(v){
	    	BOGen.apirest("/"+this.Name,Object.assign({type:'getDocType', id:v}),(e,resp)=>{
				if(e) return console.log(v);
				this.DocType = resp;
				if(this.row.td_doc_type) this.$set(this.row, "td_doc_type", this.row.td_doc_type)
			},'POST')
	    },
  	}
}
</script>

<template>
	<div class="container-fluid">
		<PageTitle></PageTitle>
		
		<!-- ======================================================================== 
			LIST DATA
		============================================================================= -->
		<div class="panel panel-flat" v-if="!$route.params.id">
			<div class="panel-body panel-filter">
				<VForm @resp="search" id="form_budget">
					<div class="row">
						<div class="col-sm-3">
							<h3 class="box-title">{{ObjectName}} List 
								<!-- <span v-if="data.total">({{(data.total||0).format()}})</span> -->
							</h3>
						</div>
						<div class="col-sm-9"></div>
					</div>
					<div class="row">
						<div class="col-sm-3">
							<div class="input-group">
								<div class="input-group-addon"><span class="ti-calendar"></span></div>
		                      	<DateRangePicker v-model="filter.rangeDate" placeholder="Range Date"></DateRangePicker>
		                    </div>	
						</div>
						<div class="col-sm-2">
							<select2 :options="DocType" :object="['mdoc_id','mdoc_initial']" v-model="filter.doc" class="form-control">
								<option value="">Doc Type</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<select2 :options="mrClient" :object="['mc_id','mc_name']" v-model="filter.client" class="form-control">
								<option value="">Client</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<select2 :options="ClientProject" :object="['tp_id','tp_name']" v-model="filter.project" class="form-control">
								<option value="">Project</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<div class="has-feedback has-feedback-left">
								<input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
								<div class="form-control-feedback">
									<i class="icon-search4 text-size-base text-muted"></i>
								</div>
							</div>
						</div>
						<div class="col-sm-1">
							<router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
						</div>
					</div>
				</VForm>
			</div>
			<div class="panel-body">
				<div class="row">
			        <div class="col-md-3">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>Total Document</strong>
			                	<span v-if="filter.rangeDate">|<strong>{{ total_document_range }}</strong></span>
			                	<span>{{ total_document }}</span>
			                </h3>
			            </div>
			        </div>
			        <div class="col-md-3" v-for="(v1,k1) in doc_department" :key="k1">
			        	<div class="panel_box_project table-responsive">
			                <h3><strong>{{ v1.mdd_name }}</strong>
			                	<span>{{ v1.total }}</span>
			                </h3>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="table-responsive ajax-table">
				<table class="table table-hover table-bordered">
					<thead>
						<tr>
							<th>#</th>
							<th>{{ fields.td_name }}</th>
							<th>{{ fields.td_project_id }}</th>
							<th>{{ fields.td_client_id }}</th>
							<th>{{ fields.td_doc_department }}</th>
							<th>{{ fields.td_create_date }}</th>
							<!-- <th>{{ fields.td_is_active }}</th> -->
							<th width="120px">Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(v,k) in data.data" :key="k">
							<td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
							<td>
								<a class="btn_copy" v-clipboard:copy="v.td_number" v-tooltip="'Copy Document ID'">
									{{v.td_name}}
								</a>
								<!-- <br><small><strong>{{v.td_number}}</strong></small> -->
							</td>
							<td>
								<a class="btn_copy" v-clipboard:copy="v.project_number" v-tooltip="'Copy Project ID'">
									{{v.project_name}} 
								</a>
								<!-- <br><small><strong>{{v.project_number}}</strong></small> -->
							</td>
							<td>
								<a class="btn_copy" v-clipboard:copy="v.client_code" v-tooltip="'Copy Client ID'">
									{{v.client_name}} 
								</a>
								<!-- <br><small><strong>{{v.client_code}}</strong></small> -->
							</td>
							<td>{{v.docDepartment}}</td>
							<td>{{v.create_date}}</td>
							<!-- <td><StatusLabel :status="v.status"></StatusLabel></td> -->
							<td class="btn-action text-center">
								<a href="javascript:;" class="icon_action" @click="openDetail(v)" v-tooltip="'View Detail'"><i class="fa fa-eye"></i></a>

								<router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
								<a href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
							</td>
						</tr>
						<tr v-if="NotFound">
							<td colspan="99">
								<h3 class="tc">{{NotFound}}</h3>
							</td>
						</tr>
						<tr v-if="data.data===false">
							<td colspan="99">
								<LoadingSpinner light></LoadingSpinner>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="panel-body">
				<div class="pull-right">
					<Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<VModal name="addNewAccessType" title="Add Access Type" method="post" noFooter @resp="submitAccessType">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="mdat_name" v-model="row2.mdat_name" mandatory :attr="{class:'input_capitalize', required:true}"></BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mdat_is_active" mandatory>
						<div class="radio-group">
							<radio name="mdat_is_active" v-model="row2.mdat_is_active" option="Y" :attr="validation('mdat_is_active')">Active</radio>
							<radio name="mdat_is_active" v-model="row2.mdat_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewDocDepartment" title="Add Doc Department" method="post" noFooter @resp="submitDocDepartment">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="mdd_name" v-model="row2.mdd_name" mandatory :attr="{class:'input_capitalize', required:true}"></BoField>
					<BoField name="mdd_desc" mandatory>
						<textarea name="mdd_desc" rows="4" class="form-control" v-model="row2.mdd_desc" v-bind="validation('mdd_desc')" required=""></textarea>
					</BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mdd_code" v-model="row2.mdd_code" mandatory :attr="{required:true}" onkeypress="return numberKey(event)"></BoField>
					<BoField name="mdd_is_active">
						<div class="radio-group">
							<radio name="mdd_is_active" v-model="row2.mdd_is_active" option="Y" :attr="validation('mdd_is_active')">Active</radio>
							<radio name="mdd_is_active" v-model="row2.mdd_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewDocType" title="Add Doc Type" method="post" noFooter @resp="submitDocType">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<!-- <BoField name="mdoc_mat_id" mandatory>
						<select2 name="mdoc_mat_id" v-bind="validation('mdoc_mat_id')" :options="DocAccessTypePopup" :object="['mdat_id','mdat_name']" v-model="row2.mdoc_mat_id" class="form-control" multiple required></select2>
					</BoField> -->
					<BoField name="mdoc_initial" v-model="row2.mdoc_initial" mandatory :attr="{required:true}"></BoField>
					<BoField name="mdoc_name" v-model="row2.mdoc_name" mandatory :attr="{required:true}"></BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mdoc_desc">
						<textarea name="mdoc_desc" rows="4" class="form-control" v-model="row2.mdoc_desc" v-bind="validation('mdoc_desc')"></textarea>
					</BoField>
					<BoField name="mdoc_is_active">
						<div class="radio-group">
							<radio name="mdoc_is_active" v-model="row2.mdoc_is_active" option="Y" :attr="validation('mdoc_is_active')">Active</radio>
							<radio name="mdoc_is_active" v-model="row2.mdoc_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewClient" title="Add Client" method="post" noFooter @resp="submitClient">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="mc_name" v-model="row2.mc_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mc_initial" v-model="row2.mc_initial" mandatory :attr="{class:'input_capitalize', required:true}"></BoField>
					<BoField name="mc_join_date">
						<div class="input-group">
	                      	<DatePicker name="mc_join_date" v-model="row2.mc_join_date" v-bind="validation('mc_join_date')"></DatePicker>
	                      	<div class="input-group-addon"><span class="ti-calendar"></span></div>
	                    </div>
					</BoField>
					<BoField name="mc_comp_address">
						<textarea name="mc_comp_address" rows="4" class="form-control" v-model="row2.mc_comp_address" v-bind="validation('mc_comp_address')"></textarea>
					</BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mc_comp_name" v-model="row2.mc_comp_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mc_phone" v-model="row2.mc_phone" mandatory :attr="{required:true}"></BoField>
					<BoField name="mc_url" v-model="row2.mc_url"></BoField>
					<BoField name="mc_is_active" mandatory>
						<div class="radio-group">
							<radio name="mc_is_active" v-model="row2.mc_is_active" option="Y" :attr="validation('mc_is_active')">Active</radio>
							<radio name="mc_is_active" v-model="row2.mc_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
				<div class="col-sm-12">
					<h3>Contact Person</h3>
					<table class="table table-bordered">
						<thead>
							<tr>
								<th colspan="10" class="text-right" style="border: 1px solid transparent;">
									<button type="button" class="btn btn-primary" @click="row2.contact_person.push({})">Add Contact Person</button>
								</th>
							</tr>
							<tr>
								<th class="lbl_popup">Salutation <span class="text-danger">*</span></th>
								<th class="lbl_popup">Fullname <span class="text-danger">*</span></th>
								<th class="lbl_popup">Email</th>
								<th class="lbl_popup">Phone Number</th>
								<th class="lbl_popup">Position</th>
								<th class="lbl_popup" v-if="row2.contact_person.length>1"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(v3,k3) in row2.contact_person">
								<td>
									<select2 :options="MrSalutation" v-model="v3.mcc_salutation" class="form-control">
										<option value="">Salutation</option>
									</select2>
								</td>
								<td>
									<input type="text" v-model="v3.mcc_name" class="form-control" required="">
								</td>
								<td>
									<input type="email" v-model="v3.mcc_email" class="form-control">
								</td>
								<td>
									<input type="text" v-model="v3.mcc_phone" class="form-control">
								</td>
								<td>
									<input type="text" v-model="v3.mcc_position" class="form-control">
								</td>
								<td v-if="row2.contact_person.length>1">
									<button type="button" class="btn btn-danger" @click="row2.contact_person.length>1 ? row2.contact_person.splice(k3,1) : ''"><i class="icon-trash"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewCP" title="Add Contact Person" method="post" noFooter @resp="submitCP">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-12" style="margin-bottom: 25px;">
					<label class="">Salutation <span class="text-danger">*</span></label>
					<select2 :options="MrSalutation" name="mcc_salutation" v-model="row2.mcc_salutation" :attr="{required:true}" class="form-control">
						<option value="">Salutation</option>
						option
					</select2>
				</div>
				<div class="col-sm-6">
					<BoField name="mcc_name" v-model="row2.mcc_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="mcc_position" v-model="row2.mcc_position"></BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mcc_email" v-model="row2.mcc_email"></BoField>
					<BoField name="mcc_phone" v-model="row2.mcc_phone"></BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="addNewProject" title="Add Project" method="post" noFooter @resp="submitProject">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="tp_name" v-model="row2.tp_name" mandatory :attr="{required:true}"></BoField>
					<BoField name="tp_desc">
						<textarea name="tp_desc" rows="4" class="form-control" v-model="row2.tp_desc" v-bind="validation('tp_desc')"></textarea>
					</BoField>
					<BoField name="tp_create_date" mandatory>
						<div class="input-group">
	                      	<DatePicker name="tp_create_date" v-model="row2.tp_create_date" v-bind="validation('tp_create_date')" :attr="{required:true}"></DatePicker>
	                      	<div class="input-group-addon"><span class="ti-calendar"></span></div>
	                    </div>
					</BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="tp_cp_id" mandatory>
						<select2 name="tp_cp_id" v-bind="validation('tp_cp_id')" :options="ClientContactPopup" :object="['mcc_id','mcc_name']" v-model="row2.tp_cp_id" class="form-control" multiple :attr="{required:true}">
						</select2>
					</BoField>
					<BoField name="tp_initial" v-model="row2.tp_initial" mandatory :attr="{class:'input_capitalize', required:true}"></BoField>
					<BoField name="tp_prod_type" mandatory>
						<select2 name="tp_prod_type" v-bind="validation('tp_prod_type')" :options="DocProductType" :object="['mpt_id','mdpt_name']" v-model="row2.tp_prod_type" class="form-control" required :attr="{required:true}">
							<option value="">-- Select Type --</option>
						</select2>
					</BoField>
					<BoField name="tp_is_active">
						<div class="radio-group">
							<radio name="tp_is_active" v-model="row2.tp_is_active" option="Y" :attr="validation('tp_is_active')">Active</radio>
							<radio name="tp_is_active" v-model="row2.tp_is_active" option="N">Inactive</radio>
							<radio name="tp_is_active" v-model="row2.tp_is_active" option="P">Pending</radio>
						</div>
					</BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="detailDocument" title="Detail Document" method="post" noFooter>
			<table class="table">
				<tbody>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Access Type</h4>
								<p>{{ detail.doc_access_type }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Doc Type</h4>
								<p>{{ detail.doc_type }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Department</h4>
								<p>{{ detail.doc_department }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Create Date</h4>
								<p>{{ detail.create_date }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Client</h4>
								<p>{{ detail.client }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Project</h4>
								<p>
									{{ detail.project_name }}
									<span class="label label-sm no_radius" :style="'background:#'+detail.project_color">{{ detail.project_initial }}</span>
								</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Doc Name</h4>
								<p>{{ detail.td_name }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Contact Person</h4>
								<p>
									<span v-for="(v,k) in detail.client_contact" class="label label-sm no_radius btn-warning">{{ v.mcc_name }}{{ v.mcc_position }}</span>
								</p>
							</div>
						</td>						
					</tr>
					<tr>
						<td colspan="2">
							<div class="detail_report">
								<h4>Doc No</h4>
								<p>{{ detail.td_number }}</p>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</VModal>

		<!-- ======================================================================== 
			FORM CRUD	
		============================================================================= -->
		<div class="panel panel-flat" v-if="$route.params.id">
			<VForm @resp="submitForm" method="post">
				<div class="panel-heading">
					<h2 class="panel-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h2>
				</div>	
				<div class="panel-body">
					<div class="info"></div>
					<div class="row">
						<div class="col-sm-6">
							<BoField name="td_doc_access_type" v-model="row.td_doc_access_type">
								<select2 v-if="!row.id" name="td_doc_access_type" v-bind="validation('td_doc_access_type')" :options="DocAccessType" :object="['mdat_id','mdat_name']" v-model="row.td_doc_access_type" class="form-control" @change="addNewAccessType($event)">
									<option value="">-- Select Access Type --</option>
								</select2>
								<input v-if="row.id" type="text" class="form-control" readonly="" :value="row.access_type">
							</BoField>
							<BoField name="td_doc_type" v-model="row.td_doc_type">
								<select2 v-if="!row.id" name="td_doc_type" v-bind="validation('td_doc_type')" :options="DocType" :object="['mdoc_id','mdoc_name']" v-model="row.td_doc_type" class="form-control" @change="addNewDocType($event)">
									<option value="">-- Select Type --</option>
								</select2>
								<input v-if="row.id" type="text" class="form-control" readonly="" :value="row.doc_type">
							</BoField>
							<BoField name="td_client_id">
								<select2 name="td_client_id" v-bind="validation('td_client_id')" :options="mrClient" :object="['mc_id','mc_name']" v-model="row.td_client_id" class="form-control" @change="addNewClient($event)">
									<option value="">-- Select Client --</option>
								</select2>
							</BoField>	
							<BoField name="td_project_id">
								<select2 name="td_project_id" v-bind="validation('td_project_id')" :options="ClientProject" :object="['tp_id','tp_name']" v-model="row.td_project_id" class="form-control" @change="addNewProject($event)">
									<option value="">-- Select Project --</option>
								</select2>
							</BoField>	
						</div>
						<div class="col-sm-6">
							<BoField name="td_doc_department" v-model="row.td_doc_department">
								<select2 v-if="!row.id" name="td_doc_department" v-bind="validation('td_doc_department')" :options="DocDepartment" :object="['mdd_id','mdd_name']" v-model="row.td_doc_department" class="form-control" @change="addNewDocDepartment($event)">
									<option value="">-- Select Department --</option>
								</select2>
								<input v-if="row.id" type="text" class="form-control" readonly="" :value="row.department">
							</BoField>
							<BoField name="td_name" v-model="row.td_name"></BoField>
							<BoField name="td_cp">
								<select2 name="td_cp" v-bind="validation('td_cp')" :options="ClientContact" :object="['mcc_id','mcc_name']" v-model="row.td_cp" class="form-control" @change="addNewCP($event)">
									<option value="">-- Select Contact Person --</option>
								</select2>
							</BoField>
							<!-- <BoField name="td_is_active">
								<div class="radio-group">
									<radio name="td_is_active" v-model="row.td_is_active" option="Y" :attr="validation('td_is_active')">Active</radio>
									<radio name="td_is_active" v-model="row.td_is_active" option="N">Inactive</radio>
								</div>
							</BoField> -->							
						</div>
						<div class="col-xs-12">
							<div class="text-right">
								<button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
							</div>
						</div>
					</div>
				</div>
			</VForm>
		</div>
	</div>
</template>
